@use "variables" as *;

.itemDiv {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title {
  font-size: $fontSize-xxs;
  font-weight: normal;
}

.value {
  font-size: $fontSize-m;
}

.loadingIndicator {
  width: 19px !important;
  height: 19px !important;
}
